<template>
  <div class="modal-overlay">
    <div class="modal">
      <div class="close-modal" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'xmark']" size="lg" style="color: #676879;" />
      </div>
      <h2 style="margin-top: 0; margin-bottom: 1rem;">{{ $t('intensity.name') }} :</h2>
      <input
        type="text"
        v-model="intensity"
        style="width: 100%; height: 2.5rem; margin-bottom: 1rem;"
      >
        <div class="flex right">
        <div class="bold pointer" @click="$emit('close')">
          {{ $t('general.cancel') }}
        </div>
        <div class="blue-button" :class="!intensity ? 'inactive' : ''" @click="$emit('addIntensity', intensity)">
          {{ $t('general.validateCreation') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import instance from '../../main';


export default {
  components: {
  },
  props: {
  },
  data() {
    return{
      intensity: null,

    }
  },
  async mounted() {

  },
  computed: {

  },
  methods: {


  },
  created() {

  }
}

</script>
